import axios from 'axios';

const clientId = process.env.VUE_APP_CLIENT_ID;
const redirectUri = process.env.VUE_APP_REDIRECT_URI;
const authorizeUrl = process.env.VUE_APP_AUTHORIZE_URL+clientId+'&redirect_uri='+redirectUri;
const tokenInfoUrl = process.env.VUE_APP_TOKEN_INFO_URL
const tokenCidadaoUrl = process.env.VUE_APP_CIDADAO_URL
const userKey = process.env.VUE_APP_CLIENT_ID

export default {
  userKey,
  authorizeUrl,
  tokenInfoUrl,
  getInfoToken(token){
    return axios.get(tokenInfoUrl, {
      headers: { 
        Authorization: `Bearer ${token}`
      }
    });
  },
  getInformacoesCidadao(token){
   return axios.get(tokenCidadaoUrl, {
      headers: { 
        Authorization: `Bearer ${token}`
      }
    });
  },
  getHashValue(key) {
    var matches = location.hash.match(new RegExp(key + "=([^&]*)"));
    return matches ? matches[1] : null;
  }  
}